

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import NavigationMenu from './components/NavigationMenu/NavigationMenu';


import Home from './pages/Home/Home';
import News from './pages/News/News';
import Works from './pages/Works/Works';
import WorkDetail from './pages/Works/WorkDetail';
import Members from './pages/Members/Members';

import Resources from './pages/Resources/Resources';
import ResourceDetail from './pages/Resources/ResourceDetail';

import Footer from './components/Footer/Footer';

function App() {
  return (
    <BrowserRouter>
      <NavigationMenu />
      
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          
          {/* Worksのページにコンポーネントを表示 */}
          <Route path="/works" element={<Works />} />
          <Route path="/works/:id" element={<WorkDetail />} />
          
          <Route path="/members" element={<Members />} />
          
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:id" element={<ResourceDetail />} />
        </Routes>
      </main>
      
      <Footer />
      
    </BrowserRouter>
  );
}

export default App;